import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-event-previews-list-modal',
  templateUrl: './event-previews-list-modal.component.html',
  styleUrls: ['./event-previews-list-modal.component.scss']
})
export class EventPreviewsListModalComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('items') items: any[] = [];
}
